import { html } from 'lit';
import type { Content } from '../entities';

export const content: Content = {
  title: 'Get your Package or Integration listed on the Marketplace',
  displayName: 'Listing your package or integration',
  description:
    'Do you want to be listed on the official Umbraco Marketplace? Follow this guide to get your package or integration listed on the Umbraco Marketplace',
  html: html`
    <p>
      Documentation for listing a package on the Marketplace can be found at the
      <a
        href="https://docs.umbraco.com/umbraco-dxp/marketplace/listing-your-package"
        target="_blank"
        >Umbraco Documentation website</a
      >.
    </p>
    <p>
      Once you have prepared your package for listing, the
      <a href="/validate">validation tools</a> are available to verify the
      details you are providing.
    </p>

    <h4>Feedback</h4>
    <p>
      If you run into any issues with listing your package, please file an issue
      on the
      <a
        href="https://github.com/umbraco/Umbraco.Marketplace.Issues/issues/"
        target="_blank"
        >tracker</a
      >.
    </p>
    <p>
      We'll also periodically send details of updates made to registered package
      developers.
    </p>
    <p>
      If you aren't currently receiving these updates from Umbraco you can
      <a href="https://umbraco.activehosted.com/f/6" target="_blank">
        sign up for this newsletter here </a
      >.
    </p>
  `,
};
